// extracted by mini-css-extract-plugin
export default {"wrapper":"Category_wrapper__HTrFm","title":"Category_title__1C+rp","not-found":"Category_not-found__qGIow"};